import { useRouter } from '@/i18n/navigation'
import type { EnterpriseCheckoutRoute, PrivateCheckoutRoute } from '@/shared/routes'
import { useGlobalStore } from '@/shared/store/provider'

export const usePurchaseFlowNavigation = () => {
  const router = useRouter()
  const { _pageCustomerType } = useGlobalStore((state) => state.system)
  const isEnterprise = _pageCustomerType === 'enterprise'

  const navigateNextPage = (
    route: PrivateCheckoutRoute,
    enterpriseRoute: EnterpriseCheckoutRoute,
  ) => {
    router.push({ pathname: isEnterprise ? enterpriseRoute : route })
  }

  return navigateNextPage
}
